import React from 'react';
import {Field, Formik, FormikProps, FormikHelpers} from 'formik';

import * as handlers from './handlers';
import {Form, Button, Popup} from '@components';
import {Props} from './types';
import _Base from './../_Base';
import validations from '@validations';
import constants from '@constants';

import './index.scss';

const Resend: React.FC<Props> = props => {
  const initialValues = {
    isEmailSending: true,
    isSMSSending: false,
    isConnectSending: false,
  };

  return (
    <_Base
      isModal={props.isModal}
      handleCloseModal={props.handleCloseModal}
      isAutoClose={false}
      size="sm"
      title={props.title}
    >
      <div className="a_resend-modal">
        <div className="w__message">{props.message}</div>
        <Formik
          initialValues={initialValues}
          onSubmit={(values: any, formikHelpers: FormikHelpers<any>) => {
            handlers.submit(
              values,
              formikHelpers,
              props.notification,
              props.me,
              props.handleCloseModal,
              props.match.params,
              props.setIsFailedSendModal,
              props.isFailed
            );
          }}
          validate={validations.notifications.resend}
        >
          {(formProps: FormikProps<any>) => {
            return (
              <>
                <div className="w__field">
                  <Form.Label required text="通知手段" />
                  <div className="w__check-box">
                    <div className="w__form">
                      <Field
                        name="isEmailSending"
                        component={Form.Checkbox}
                        label="メール"
                        disabled={props.me.plan === constants.PLAN.FREE}
                      />
                    </div>
                    <div className="w__form">
                      <Field
                        name="isSMSSending"
                        component={Form.Checkbox}
                        label="SMS"
                        disabled={!props.me.plan}
                      />
                    </div>
                    <div className="w__form">
                      <Field
                        name="isConnectSending"
                        component={Form.Checkbox}
                        label="電話"
                        disabled={props.me.plan !== constants.PLAN.SAFETY_X}
                      />
                      {props.me.plan === constants.PLAN.SAFETY && (
                        <Popup.Normal content="電話での安否確認は、エンタープライズプランでのみご利用可能です" />
                      )}
                    </div>
                  </div>
                </div>
                <div className="w__modal-buttons">
                  <Button.Normal
                    text="キャンセル"
                    onClick={() => props.handleCloseModal(!props.isModal)}
                    disabled={formProps.isSubmitting}
                  />
                  <Button.Normal
                    text="送信する"
                    onClick={() => formProps.handleSubmit()}
                    color="yellow"
                    disabled={props.disabled || formProps.isSubmitting}
                    loading={formProps.isSubmitting}
                  />
                </div>
              </>
            );
          }}
        </Formik>
      </div>
    </_Base>
  );
};

export default Resend;
